module.exports = __webpack_public_path__ + "media/images/shopping-cart-b11701c3d4a65c2ffdff23affe708934.png";